/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetEvidences200ResponseInnerErrors
 */
export interface GetEvidences200ResponseInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerErrors
     */
    'detectedDpi'?: GetEvidences200ResponseInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerErrors
     */
    'calculatedDpi'?: GetEvidences200ResponseInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerErrors
     */
    'colorGradation'?: GetEvidences200ResponseInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerErrors
     */
    'heightMillis'?: GetEvidences200ResponseInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerErrors
     */
    'widthMillis'?: GetEvidences200ResponseInnerErrorsWidthMillisEnum;
}

export const GetEvidences200ResponseInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerErrorsDetectedDpiEnum = typeof GetEvidences200ResponseInnerErrorsDetectedDpiEnum[keyof typeof GetEvidences200ResponseInnerErrorsDetectedDpiEnum];
export const GetEvidences200ResponseInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerErrorsCalculatedDpiEnum = typeof GetEvidences200ResponseInnerErrorsCalculatedDpiEnum[keyof typeof GetEvidences200ResponseInnerErrorsCalculatedDpiEnum];
export const GetEvidences200ResponseInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetEvidences200ResponseInnerErrorsColorGradationEnum = typeof GetEvidences200ResponseInnerErrorsColorGradationEnum[keyof typeof GetEvidences200ResponseInnerErrorsColorGradationEnum];
export const GetEvidences200ResponseInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidences200ResponseInnerErrorsHeightMillisEnum = typeof GetEvidences200ResponseInnerErrorsHeightMillisEnum[keyof typeof GetEvidences200ResponseInnerErrorsHeightMillisEnum];
export const GetEvidences200ResponseInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidences200ResponseInnerErrorsWidthMillisEnum = typeof GetEvidences200ResponseInnerErrorsWidthMillisEnum[keyof typeof GetEvidences200ResponseInnerErrorsWidthMillisEnum];


